<template>
  <div class="animated fadeIn">
    <Forms ref="frmCampanhaModelo" :title="'Adicionar novo HSM'" :showClearButton="!data.id" :showSaveButton="!data.id"
      :showBackButton="true" :disabledKeyUpEnter="true" :isModal="isModal" v-on:Clear="onClear"
      v-on:Back="$emit('Back')" v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small v-if="form.hsmName.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input :disabled="!!data.id" type="text" :placeholder="'Digite o nome do HSM'"
              v-model="form.hsmName.value" :size="form.hsmName.maxlength" :required="form.hsmName.required"
              :state="form.hsmName.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label><small v-if="form.hsmId.required" class="text-danger">*</small> ID HSM: <i class="fa fa-info-circle"
              style="font-size: 14px;" v-b-popover.hover="{
                title: 'Atenção',
                content: 'O ID deve ser ser igual ao cadastrado na Meta, e encaminhado pelo seu provedor',
                variant: 'light',
                html: true
              }" /></label>
          <div class="input-group">
            <b-form-input :disabled="!!data.id" type="text" :placeholder="'Digite o Identificador do HSM'"
              v-model="form.hsmId.value" :size="form.hsmId.maxlength" :required="form.hsmId.required"
              :state="form.hsmId.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtName">Provedor:</label>
          <div class="input-group">
            <b-form-select :disabled="!!data.id" v-model="form.provedor.value" :options="form.provedor.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="input-group">

            <div class="col-md-3" style="padding-top: 12px;">
              <label><small v-if="form.buttonCTA.required" class="text-danger">*</small> Botão de link: <i
                  class="fa fa-info-circle" style="font-size: 14px;" v-b-popover.hover="{
                    title: 'Atenção',
                    content: 'Somente se precisar de um botão de link na mensagem',
                    variant: 'light',
                    html: true
                  }" /></label>
              <toogleswitch v-model="buttonCTAValue" :required="form.buttonCTA.required" label="Botão de link" />
            </div>
          </div>
        </div>
        <div v-if="form.provedor.value === 'NXZAP'" class="col-md-4">
          <div class="input-group">

            <div class="col-md-5" style="padding-top: 12px;">
              <label><small v-if="form.hasImage.required" class="text-danger">*</small> Imagem no Cabeçalho: <i
                  class="fa fa-info-circle" style="font-size: 14px;" v-b-popover.hover="{
                    title: 'Atenção',
                    content: 'Somente se precisar de uma imagem no cabeçalho, só disponivel no NxZap',
                    variant: 'light',
                    html: true
                  }" /></label>
              <toogleswitch name='t' v-model="imageHeaderValue" :required="form.hasImage.required"
                label="Imagem no Cabeçalho" />
            </div>
            <div class="col-md-6" style="padding-top: 12px;">
              <b-input-group v-if="imageHeaderValue">
                <b-form-input placeholder="Código da imagem" disabled v-model="idImageValue"></b-form-input>
                <b-input-group-append>
                  <b-button v-b-modal.modal-1>Gerar</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>

          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label>Mensagem:<i class="fa fa-info-circle" style="font-size: 14px;" v-b-popover.hover="{
            title: 'Atenção',
            content: 'O texto deve ser igual ao cadastrado na Meta. Substitua as variáveis no texto (nome, celular, e-mail) utilizando o botão abaixo',
            variant: 'light',
            html: true
          }" /></label>
          <div class="nxbr-toolbar" v-if="!data.id">
            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-address-card text-third" />
              </template>
              <b-dropdown-item href="javascript:void(0);"
                @click.prevent="onAddingOption('@Nome@', 'templateText')">Nome</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);"
                @click.prevent="onAddingOption('@Telefone@', 'templateText')">Telefone</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);"
                @click.prevent="onAddingOption('@Email@', 'templateText')">E-mail</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);"
                @click.prevent="onAddingOption('@NOME_GERENTE@', 'templateText')">Nome do Gerente</b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="input-group">
            <b-form-textarea :disabled="!!data.id" v-model="form.hsmText.value" ref="templateText"
              :placeholder="'Olá @Nome@,\n' + '\n' + 'É com grande satisfação que damos as boas-vindas à Nexum! Estamos felizes em tê-lo(a) como parte de nossa família. Por favor, revise as informações de contato que você nos forneceu: Celular: @Celular@ e Email: @Email@.\n\n Estamos aqui para apoiá-lo(a) em sua jornada conosco e ansiosos para começar esta jornada junto com você.'"
              :rows="8" :size="form.hsmText.maxlength" @input="updateDynamicFields" :noResize="true">
            </b-form-textarea>
          </div>
        </div>
        <p class="col-md-12">
          {{ form.hsmText.value ? form.hsmText.value.length : 0 }} / 500
        </p>
      </div>
      <div class="form-group row">
        <div v-for="(value, key) in dynamicFields" :key="key" class="col-md-3 pt-1">
          <label>{{ key }}:</label>
          <div class="input-group">
            <b-dropdown :disabled="!!data.id" size="sm" variant="addon" no-caret>
              <template #button-content>
                <i class="fas fa-address-card text-third" />
              </template>
              <b-dropdown-item href="javascript:void(0);"
                @click.prevent="onAddingVariable('@Nome@', key)">Nome</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);"
                @click.prevent="onAddingVariable('@Telefone@', key)">Telefone</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);"
                @click.prevent="onAddingVariable('@Email@', key)">E-mail</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingVariable('@NOME_GERENTE@', key)">Nome
                do
                Gerente</b-dropdown-item>
            </b-dropdown>
            <b-form-input class="" :disabled="!!data.id" v-model="dynamicFields[key]"
              :placeholder="`Digite o valor para ${key}`"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
    <ModalImage @idImage="addValueId" />

  </div>
</template>
<script>
/* https://github.com/hinesboy/mavonEditor/blob/master/README-EN.md */
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ModalImage from '@/views/private/configurations/hsm/components/modal/ModalImage.vue'
import HsmModel from '@/shared/models/configurations/hsmmodel.js'
import HsmForms from '@/views/private/configurations/hsm/components/add/hsm-form.js'

import HsmRepository from '../../../../../../shared/http/repositories/configurations/hsm'
import enumVariaveisHsm from '@/views/private/configurations/hsm/components/enums/enumVariaveisHsm.js'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'HsmAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: HsmModel,
      form: HsmForms,
      idImageValue: '',
      dynamicFields: {},
      logo: null,
      hsmVariables: enumVariaveisHsm,
      buttonCTA: false,
      imageHeader: false,
      toolbars: {
        bold: false,
        italic: false,
        header: false,
        underline: false,
        strikethrough: false,
        mark: false,
        superscript: false,
        subscript: false,
        quote: false,
        ol: false,
        ul: false,
        link: false,
        imagelink: false,
        code: false,
        table: false,
        fullscreen: false,
        readmodel: false,
        htmlcode: false,
        help: false,
        undo: false,
        redo: false,
        trash: false,
        save: false,
        navigation: false,
        alignleft: false,
        aligncenter: false,
        alignright: false,
        subfield: false,
        preview: false
      },
      customToolbar: {
        bold: {
          name: 'Negrito',
          icon: 'fa-mavon-bold text-third',
          prefix: '<b>',
          subfix: '</b>',
          str: ''
        },
        italic: {
          name: 'Itálico',
          icon: 'fa-mavon-italic text-third',
          prefix: '<i>',
          subfix: '</i>',
          str: ''
        },
        header: {
          name: 'Cabeçalho',
          icon: 'fa-mavon-header text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Cabeçalho 1',
              prefix: '<h1>',
              subfix: '</h1>',
              str: ''
            },
            {
              name: 'Cabeçalho 2',
              prefix: '<h2>',
              subfix: '</h2>',
              str: ''
            },
            {
              name: 'Cabeçalho 3',
              prefix: '<h3>',
              subfix: '</h3>',
              str: ''
            },
            {
              name: 'Cabeçalho 4',
              prefix: '<h4>',
              subfix: '</h4>',
              str: ''
            },
            {
              name: 'Cabeçalho 5',
              prefix: '<h5>',
              subfix: '</h5>',
              str: ''
            },
            {
              name: 'Cabeçalho 6',
              prefix: '<h6>',
              subfix: '</h6>',
              str: ''
            }
          ]
        },
        underline: {
          name: 'Sublinhar',
          icon: 'fa-mavon-underline text-third',
          prefix: '<ins>',
          subfix: '</ins>',
          str: ''
        },
        strikethrough: {
          name: 'Tachar',
          icon: 'fa-mavon-strikethrough text-third',
          prefix: '<del>',
          subfix: '</del>',
          str: ''
        },
        variables: {
          name: 'Variáveis',
          icon: 'fa-address-card text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Nome',
              prefix: '@',
              subfix: '@',
              str: 'Nome'
            },
            {
              name: 'Email',
              prefix: '@',
              subfix: '@',
              str: 'Email'
            },
            {
              name: 'Telefone',
              prefix: '@',
              subfix: '@',
              str: 'Telefone'
            },
            {
              name: 'Link de Conversão',
              prefix: '@',
              subfix: '@',
              str: 'CTA'
            }
          ]
        },
        undo: {
          name: 'Desfazer (CTRL+Z)',
          icon: 'fa-mavon-undo text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        redo: {
          name: 'Resfazer (CTRL+Y)',
          icon: 'fa-mavon-repeat text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        trash: {
          name: 'Limpar (CTRL+BREAKSPACE)',
          icon: 'fa-trash-alt text-third',
          prefix: '',
          subfix: '',
          str: ''
        }
      }
    }
  },
  components: {
    toogleswitch,
    ModalImage
  },
  computed: {
    buttonCTAValue: {
      get () {
        return !this.data.id ? this.buttonCTA : this.form.buttonCTA.value
      },
      set (value) {
        if (!this.data.id) {
          this.buttonCTA = value
        } else {
          this.form.buttonCTA.value = value
        }
      }
    },
    imageHeaderValue: {
      get () {
        return !this.data.id ? this.imageHeader : this.form.imageHeader.value
      },
      set (value) {
        if (!this.data.id) {
          this.imageHeader = value
        } else {
          this.form.imageHeader.value = value
        }
      }
    }
  },
  methods: {
    onLoad () {
    },
    addValueId (value) {
      this.idImageValue = value
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)
        this.loadDynamicFields(obj.variaveisHsmTextoList)
        this.data.buttonCTA = !!obj.buttonCTA
        loading.pop()
      }
    },
    uploadImage () {
      if (!this.logo) return
      this.logo = this.logo.files[0].file
    },
    onCreate () {
      loading.push()
      this.data.hsmName = this.form.hsmName.value
      this.data.hsmId = this.form.hsmId.value
      this.data.hsmText = this.form.hsmText.value
      this.data.buttonCTA = (this.buttonCTA) ? 1 : 0
      this.data.hasImage = this.imageHeader
      this.data.hsmImageId = this.idImageValue
      this.data.variaveisHsmList = this.foundMarkers(this.data.hsmText)
      this.data.variaveisHsmTextoList = this.hashToObj(this.dynamicFields)
      HsmRepository.Create(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
          this.$emit('Back')
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.hsmName.value
    },
    onAddingOption (value, location, key) {
      if (location === 'templateText') {
        this.form.hsmText.value = this.form.hsmText.value + value + ' '
        this.$refs.templateText.focus()
      }
      return false
    },
    onAddingVariable (value, key) {
      this.dynamicFields[key] = value
    },
    foundMarkers (text) {
      const regexNome = /@Nome@/g
      const regexTelefone = /@Telefone@/g
      const regexEmail = /@Email@/g
      let variables = []
      if (regexNome.test(text)) variables.push(this.hsmVariables.NOME)
      if (regexTelefone.test(text)) variables.push(this.hsmVariables.TELEFONE)
      if (regexEmail.test(text)) variables.push(this.hsmVariables.EMAIL)
      return variables
    },
    updateDynamicFields () {
      const matches = this.form.hsmText.value.match(/{{(\w+)}}/g) || []
      const newFields = {}

      matches.forEach(match => {
        const key = match.replace(/{{|}}/g, '')
        if (!this.dynamicFields[key]) {
          this.$set(newFields, key, '')
        } else {
          this.$set(newFields, key, this.dynamicFields[key])
        }
      })

      this.$set(this, 'dynamicFields', newFields)
    },
    hashToObj (dynamicFields) {
      return Object.entries(dynamicFields).map(([key, value]) => ({
        variavelHSM: key,
        valorVariavelHSM: value
      }))
    },
    loadDynamicFields (variaveisHsmTextoList) {
      const loadedFields = {}
      variaveisHsmTextoList.forEach(item => {
        this.$set(loadedFields, item.variavelHSM, item.valorVariavelHSM)
      })
      this.$set(this, 'dynamicFields', loadedFields)
    }
  }

}
</script>

<style scoped>
.input-group-addon {
  z-index: 9999;
}

.mavonEditor {
  border: solid 1px #ccc;
  min-width: 100%;
  min-height: 543px;
  max-height: 543px;
  overflow: scroll;
}

.v-note-wrapper.shadow {
  border: solid 1px #ccc;
}

.markdown-body>:first-child {
  background-color: #eceff1 !important;
  border-bottom: solid 1px #cfd8dc;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon,
.v-note-wrapper .v-note-op .v-right-item .op-icon {
  color: #006a5b !important;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon.selected,
.v-note-wrapper .v-note-op .v-right-item .op-icon.selected {
  color: #006a5b !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon:hover,
.v-note-wrapper .v-note-op .v-right-item .op-icon:hover {
  color: #005c50 !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon button,
.v-note-wrapper .v-note-op .v-right-item .op-icon button {
  color: #006a5b;
}

button.op-icon {
  color: #006a5b !important;
}

.nxbr-toolbar {
  background-color: #eceff1 !important;
  border-top: solid 1px #cfd8dc;
  border-left: solid 1px #cfd8dc;
  border-right: solid 1px #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/hsm/components/add/HsmAdd.vue